module.exports = __webpack_public_path__ + "img/app-live.591b40c5.png";